// Get host dynamically for testability
export const getApiHost = () => import.meta.env.VITE_PLATFORM_API_ENDPOINT || 'https://dev.api.hotmic.io';

export const fetchWrapperPlatform = async ({ ...args }) => {
  const fetchObj = {};
  fetchObj.headers = args.headers || {};
  fetchObj.method = args.method.toUpperCase();
  fetchObj.body = args.body ? args.body : null;
  if (args.signal) fetchObj.signal = args.signal;
  fetchObj.headers['Content-Type'] = 'application/json';
  fetchObj.headers['ApiKey'] = import.meta.env.VITE_APP_KEY;
  if (args.addBearer) {
    fetchObj.headers['Authorization'] = args.token ? args.token : `Bearer ${localStorage.getItem('access_token')}`;
  }
  try {
    const host = getApiHost();
    const result = await fetch(`${host}/${args.url}`, fetchObj);
    if (args.signal?.aborted) return undefined;
    // `onResponse` lets a caller read response headers (poll-data's `Date`/`Age`
    // anchor the Live Chat panel's clock, BR-18281) without changing what every
    // existing caller gets back.
    if (result && typeof args.onResponse === 'function') {
      try {
        args.onResponse(result);
      } catch {}
    }
    return result && result.status === 204 ? result.status : await result.json();
  } catch {}
};
